import {calcUtmParams} from "../../components/model/utils";
//TODO refactor it!
//TODO extract to glossaty
export let appdata = {
    eventType: "",
    productCode: "",
    priceHeader: "",
    priceReducedHeader: "",
    priceFull: 0.0,
    priceReduced: 0.0,
    priceFullOrig: 0.0,
    priceReducedOrig: 0.0,
    priceFullIn: 0.0,
    priceReducedIn: 0.0,
    price1: 0.0,
    price1Reduced: 0.0,
    productName: "",
    amount: 0.0,
    count: 0,
    countFull: 0,
    countReduced: 0,
    errorMessage: "",
    priceInUrlAllowed:false,
    header: "",
    customerEmail: "",
    customerName: "",
    country: "",
    paymentMethod: "",
    paymentInstrument: "",
    orderId: "",
    leadAction: "",
    leadSubAction: "",
    description: "",
    redirectData: "",
    customerPhone: "",
    geoText: "",
    closed: false,
    sold: false,
    language: "",
    config: {
        priceHeaderMessage: "",
        path: "",
        fullPrice: 0,
        date: "",
        time: "",
        timezone: "",
        place: "",
        placeAddr: "",
        packages:{},
        reducedPrice: 0,
        name: "",
        miniposterResource: "",
        type: "",
        priceModel: "",
        priceMessage: "",
        flexParams: {
            minPrice: 0,
            priceEmptyMessage: "",
        }
    },
    discount: 0.0,
    discountTill: "+",
    discountTillMessage: "+",
    daysTillEvent: 0,
    key2: "",
    backgroundColor: "black",
    priceNote: "",
    priceModel: "",
    leadId: "",
    reservationId: "",
    reservationStatus: "",
    ticketBalance: 0,
    referenceId: "",
    product: {},
    admin: false,
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_content: "",
    utm_brand: "",
    utm_params: "",
    abTest1: "",
    abTest2: "",
    abTest3: "",
    message: "",
    skin: "",
    contactId: "",
    local: false,
    cmpCode: "",
    cmpVersion: "",
    cmp: {},
    geoCode: "",
    geo: {},
    setType: "",
    setLang: "",
    setVersion: "",
    spKey: "",
    spKeyRedim: "",
    setFocusCode: "",
    currentPath: {},
    currentPathObj: {},
    nextLm: {},
    currency: "",
    nextLmKey: "",
    shortPageUrl: "",
    fullPageUrl: "",
    action: "",
    eventStatus:"",
    priceInfo:{},
    messageKey:"",
    lmKey: "",
    iframeId: "",
    parentPath: "",
    viewId: "",
    viewType: "",
    prevViewId: "",
    errorMessageKey: "",
    prevViewType: "",
    testColor: "",
    purpose: "",
    testId: "",
    external_id: "",
    myIp: "",
    cashPayments:{},
    whereLoc: "",
    geoData: {},
    autoDiscount:{
        autoDiscount_percentPerDay: 0,
        autoDiscount_stepSizeDays: 0,
        autoDiscount_offsetPercent: 0,
        autoDiscount_offsetDays: 0
    }

}

export function save() {
    window.localStorage.setItem('state', JSON.stringify(appdata));
}

export function load() {
    let text = window.localStorage.getItem('state');
    let state1 = JSON.parse(text);
    appdata = state1
    if (appdata === undefined || appdata === null)
        appdata = {}
}
